import { createFileRoute, redirect } from '@tanstack/react-router'

import { get } from '@/lib/api'
import { isOidcEnabled } from '@/lib/auth/oidc-bootstrap'
import { RegistrationCompletionForm } from '@/modules/login/components/registration-completion-form'
import {
  registrationCompletionSearchSchema,
  RegistrationCompletionSearch
} from '@/types/route-search-schemas'

export const Route = createFileRoute('/registration-completion')({
  validateSearch: (search: Record<string, unknown>): RegistrationCompletionSearch => registrationCompletionSearchSchema.parse(search),
  beforeLoad: async ({ search }) => {
    // Keycloak owns credentials after the cutover: a stale invite link must not set a first
    // password nobody can use, so this collapses into the /login shim. Post-cutover registration
    // is provisioned Keycloak-side (Unity Central), never here.
    if (isOidcEnabled()) {
      throw redirect({'to': '/login'})
    }

    if (!search.token) {
      throw redirect({ to: "/login" })
    }
  },
  loader: async ({ location }) => {
    const params = new URLSearchParams(location.search)
    const token = params.get('token')

    try {
      const response = await get(`/get-user-by-token/${token}`, undefined, import.meta.env.VITE_USER_MANAGER_URL)

      if (!response) {
        return { isValidUserByToken: false }
      }

      return { isValidUserByToken: true }
    } catch {
      return { isValidUserByToken: false }
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10 bg-[#022D4F]">
      <RegistrationCompletionForm />
    </div>
  )
}
